import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {TaskModel} from "../../../tasks/models/task.model";


export class EntityRelationsIndicatorComponent implements IController {
  service: any;
  task: TaskModel;
  job: any;

  count: number;

  constructor() {
  }

  $onInit() {
    if (this.service) {
      this.count = _.sumBy(this.service.taskList, function (t) {
        return _.get(t, 'relations.length', 0);
      });
    }
    if (this.task) {
      this.count = _.get(this.task, 'relations.length', 0);
    }
    if (this.job) {
      this.count = _.sumBy(this.job.stops, function (s) {
        return _.get(s, 'relations.length', 0);
      });
    }
  }

  $onChanges(changes) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.$onInit();
    }
    if (changes.task && !changes.task.isFirstChange()) {
      this.$onInit();
    }
    if (changes.job && !changes.job.isFirstChange()) {
      this.$onInit();
    }
  }
}

angular
  .module('bringoz.admin.commons')
  .component('entityRelationsIndicator', {
    bindings: {
      service: '<?',
      task: '<?',
      job: '<?'
    },
    templateUrl: 'app/modules/commons/components/entity-relations-indicator/entity-relations-indicator.html',
    controller: EntityRelationsIndicatorComponent
  });
